export default __webpack_public_path__ + "8d642b075d8791ea4cc61fae9979a6e2.svg";